module.exports = __webpack_public_path__ + "static/img/KOessential1.54c324a3.png";